import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { HAVEN_TERM_UUID_DEV, HAVEN_TERM_UUID_PROD } from 'embed/constants'

const commonStyles = require('embed/styles/results')
const styles = require('./styles')

const PreApprovedIcon = require('./icon-preapproved.svg')

interface Props {
  partnerUuid: string
  children?: React.ReactNode
}

export const Flag = ({ partnerUuid, children }: Props) => {
  const isHavenTerm = () =>
    partnerUuid === HAVEN_TERM_UUID_DEV || partnerUuid === HAVEN_TERM_UUID_PROD ? 'Featured' : 'Recommended'

  return (
    <ThemeConsumer>
      {({ colorSecondary, fontFamilyPrimary }) => (
        <div className={commonStyles.flagContainer}>
          <div className={classnames(commonStyles.preApprovedSection, styles.ribbon)}>
            <div
              className={classnames(
                commonStyles.preApprovedFlag,
                css`
                  background-color: ${colorSecondary};
                  font-family: ${fontFamilyPrimary};
                  width: 100%;
                  margin: 0px;
                `,
              )}
            >
              <PreApprovedIcon />
              {isHavenTerm()}
            </div>
          </div>
        </div>
      )}
    </ThemeConsumer>
  )
}
